import moment from '@/plugins/vue-moment.js';

export function chatTimestamp(createdAt, timezone) {
    if (createdAt === null || createdAt === undefined || createdAt === '') return null;

    const sentAt = moment.utc(createdAt).tz(timezone).locale('en');
    if (!sentAt.isValid()) return null;

    return {
        datetime: sentAt.toISOString(),
        day: sentAt.format('YYYY-MM-DD'),
        time: sentAt.format('h:mm A'),
    };
}

export function chatDayLabel(day, timezone, now) {
    const today = moment(now).tz(timezone).startOf('day');
    const date = moment.tz(day, 'YYYY-MM-DD', timezone).locale('en').format('MMM D, YYYY');
    if (day === today.format('YYYY-MM-DD')) return `Today, ${date}`;
    if (day === today.subtract(1, 'day').format('YYYY-MM-DD')) return `Yesterday, ${date}`;
    return date;
}

export function nextChatDayDelay(timezone, now) {
    return moment(now).tz(timezone).startOf('day').add(1, 'day').valueOf() - now;
}
